/** Best-effort: ask PDF viewers to open external URI links in a new window/tab. */
export function patchPdfUriLinksNewWindow(pdf: ArrayBuffer): Uint8Array {
  const input = new Uint8Array(pdf);
  const marker = '/URI (';
  const suffix = '/NewWindow true';
  const out: number[] = [];

  for (let i = 0; i < input.length; ) {
    let isMarker = i + marker.length <= input.length;
    if (isMarker) {
      for (let j = 0; j < marker.length; j++) {
        if (input[i + j] !== marker.charCodeAt(j)) {
          isMarker = false;
          break;
        }
      }
    }

    if (!isMarker) {
      out.push(input[i]);
      i += 1;
      continue;
    }

    for (let j = 0; j < marker.length; j++) out.push(input[i + j]);
    i += marker.length;

    while (i < input.length) {
      const byte = input[i];
      out.push(byte);
      i += 1;
      if (byte === 0x5c && i < input.length) {
        out.push(input[i]);
        i += 1;
        continue;
      }
      if (byte === 0x29) break;
    }

    let ws = i;
    while (ws < input.length && (input[ws] === 0x20 || input[ws] === 0x0a || input[ws] === 0x0d)) {
      ws += 1;
    }
    const tail = String.fromCharCode(...input.slice(ws, Math.min(ws + 24, input.length)));
    if (!tail.startsWith('/NewWindow')) {
      for (const ch of suffix) out.push(ch.charCodeAt(0));
    }
  }

  return new Uint8Array(out);
}

export function downloadPdfBlob(bytes: Uint8Array, filename: string): void {
  const blob = new Blob([bytes], { type: 'application/pdf' });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.rel = 'noopener';
  anchor.click();
  URL.revokeObjectURL(url);
}

export function saveWorkItemsPdf(doc: import('jspdf').jsPDF, filename: string): void {
  const patched = patchPdfUriLinksNewWindow(doc.output('arraybuffer'));
  downloadPdfBlob(patched, filename);
}

export function workItemPdfTextWithLink(
  doc: import('jspdf').jsPDF,
  text: string,
  x: number,
  y: number,
  url: string,
  options: Record<string, unknown> = {}
): number {
  return doc.textWithLink(text, x, y, { ...options, url, newWindow: true });
}
